
import { defineComponent } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"

// noinspection JSUnusedGlobalSymbols
export default defineComponent({
    name: "ContentManagementDashboard",
    components: { AclLayout },
    props: {
        services: {
            type: Object,
            required: true,
        },
    },
})
